// a library to wrap and simplify api calls
import Api from './PhiApi'

export default class PhiMetadata {

    constructor(options) {
        this.phiRef = options
        
        // this.get = function* (that, options) {
        //     let token = that.phiRef.getSession()
        //     if (token) {
        //         let response = yield Api.getMetadata({ inType: options })
        //         if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
        //             let metadata = response.data.results[0].metadata
        //             let metadataList = JSON.parse(metadata)
        //             return metadataList.map((a) => a)
        //         }
        //         else {
        //             return { error: response.problem }
        //         }
        //     }
        //     return null

        // }

        this.getMetaData = function* (that, options) {
          const { metaType, config } = options
          let response, headerconfig
          
          let token = that.phiRef.getSession()
          if (token) {
            if (metaType === 'zones') {
              headerconfig = config || {}
              response = yield Api.getZones(headerconfig)
            }
            else if (metaType === 'city') {
              headerconfig = config || {stateId: 2}
              response = yield Api.getCity(headerconfig)
            }
            else if (metaType === 'district') {
              headerconfig = config || {}
              response = yield Api.getDistrict(headerconfig)
            }
            else if (metaType === 'state') {
              headerconfig = config || {countryId: 1}
              response = yield Api.getStates(headerconfig)
            }
            else if (metaType === 'country') {
              headerconfig = config || {}
              response = yield Api.getCountry(headerconfig)
            }           
            if (response && response.ok && response.data && response.data.results && response.data.results.length > 0) {
              let metadata = response.data.results
              return metadata.map((a) => a)
            }
            else {
                return { error: response.problem }
            }
          }            
        }

        
        this.fetchNurseMeta = function* (that, config) {
          let token = that.phiRef.getSession()
          if (token) {
              let response = yield Api.fetchNurseMeta(config)
              if (response && response.ok && response.data && response.data.results && response.data.results.length > 0) {
                  return JSON.parse(response.data.results[0].metadata)[0]
              }
          }
          return null    
        }

        this.getVaccinationV2 = function* (that, config) {
          let token = that.phiRef.getSession();
          if (Boolean(token) && Boolean(token.jwt)) {
              let response = yield Api.getVaccinationV2({inCountryId: config.countryId});

              if(!response.ok) {
                  return { ok: false, error: response.problem }
              }
              else if (response.data && response.data.status === 200) {
                  return {ok: true, data: response.data};
              }
              else {
                  return { ok: false, error: 'Failed to submit appointment request' }
              }
          }
          else {
              return { ok: false, error: 'authentication error' }
          }
      }
    }


}


// WEBPACK FOOTER //
// ./src/Phi/PhiMetadata.js